import { render, staticRenderFns } from "./ContentWrap.vue?vue&type=template&id=e228ff2a&"
var script = {}
import style0 from "./ContentWrap.vue?vue&type=style&index=0&id=e228ff2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports